<script lang="ts">
  import { user } from '../lib/stores/auth';

  // Account-page-only banner shown when the Resend webhook has flagged
  // the user's email as bouncing. The Phase A pending-email-change flow
  // already handles updates; this banner is just a sign-post pointing
  // the user to the email field on the Profile tab.
  //
  // We deliberately don't render this globally (unlike the verify
  // banner) — a bouncing inbox doesn't break gameplay, just notices.

  interface Props {
    /** Switch the parent's tab state to 'profile' so the user lands
     *  on the email field with one click. */
    onUpdateEmail?: () => void;
  }

  let { onUpdateEmail }: Props = $props();

  const bouncing = $derived($user?.email_bouncing === true);
</script>

{#if bouncing}
  <div class="bouncing-banner" role="status">
    <p class="bouncing-banner__message">
      <strong>We can&rsquo;t deliver email to your address.</strong>
      Bounces from your provider have suppressed sends. Update your
      email to receive verification, receipts, and account notices again.
    </p>
    {#if onUpdateEmail}
      <button
        type="button"
        class="bouncing-banner__action"
        onclick={onUpdateEmail}
      >
        Update email
      </button>
    {/if}
  </div>
{/if}
